import sublimationPrinting from "./templates/sublimation-printing";

export default [
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `<p>Брелок квадратный с полной запечаткой 32х32 мм</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${sublimationPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
